import { GET_WORKSHOP_CALENDAR_VISITS } from '../constants/visitsCalendar';

const initialState = {
  ownerId: null,
  visitsCalendar: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_WORKSHOP_CALENDAR_VISITS:
      return {
        ...state,
        ownerId: action.ownerId,
        visitsCalendar: action.visits,
      };
    default:
      return state;
  }
};
